export type RouterParams = {
  matchId: string | null;
  teamId: string | null;
  pageSource: string | null;
  sid: string | null;
};

export type FifaClaimButton = {
  img?: string;
  status: number;
};

export type FifaUiConfig = {
  pageTitle?: string;
  pageTitleImage?: string;
  pageMainImage?: string;
  pageGetCoupon?: string;
  pageSuccessButton?: string;
  pageButton?: string;
  /** 首页下发的三张按钮切图（与 claimButton 同级） */
  receiveButton?: string;
  receiveSuccessButton?: string;
  activityEndButton?: string;
  ruleDesc?: string;
  title?: string;
  titleImg?: string;
  pageBackground?: string;
  themeBackground?: string;
  themeCover?: string;
  instructions?: string;
  pageKey?: string;
  claimButton?: FifaClaimButton;
  [key: string]: string | FifaClaimButton | undefined;
};

export type FifaCouponCard = {
  couponName?: string;
  multiStyleImg?: string;
  receiveFlag?: number;
  singleStyleImg?: string;
  type?: number;
  seq?: number;
  receiveId?: string | number;
  couponPic?: string;
  couponLogo?: string;
  price?: string;
  tradeStartTime?: string;
  tradeEndTime?: string;
};

export type FifaGetCouponPageConfig = {
  status: number;
  cardType: string;
  multipleCards: FifaCouponCard[] | null;
  singleCard: FifaCouponCard | null;
  uiConfig: FifaUiConfig | null;
};

/** POST /market/api/fifa/coupon/page/binding 单条券结果 */
export type FifaCouponBindingItem = {
  msg?: string | null;
  couponName?: string;
  code?: string;
  success?: boolean;
  receiveQuantity?: number;
  /** 若下发则可精确对齐 index 配图（可与首页 receiveId 类型一致，如 number） */
  receiveId?: string | number;
};

/** binding 接口 data */
export type FifaCouponBindingData = {
  coupons?: FifaCouponBindingItem[];
  message?: string;
  /** -1 全部失败 | 0 部分成功 | 1 全部成功 */
  retFlag?: number;
};

export enum FifaBindRetFlag {
  ALL_FAILED = -1,
  PARTIAL_SUCCESS = 0,
  ALL_SUCCESS = 1,
}
